import { Col } from '@wyz/ui';
import { IUserCustomer } from '~/common/types';
import { QuoteProductResult } from '~/purchase/components';
import {
  IBaseTyreOffer,
  IProductListState,
  IQuoteSetting,
  IQuoteTyreOffer,
  ISearchTypeArgs,
} from '~/purchase/types';

type Props = {
  items: Array<IQuoteTyreOffer>;
  quoteSetting: IQuoteSetting;
  customer: IUserCustomer;
  pointOfSaleView: boolean;
  requestedQuantity: number;
  searchType: ISearchTypeArgs['searchType'];
  searchQuery: IProductListState['searchQuery'];
  onUpdateQuery: (tyreOffer: IBaseTyreOffer) => IBaseTyreOffer | undefined;
};

function QuoteStandardDisplay({
  items,
  quoteSetting,
  customer,
  pointOfSaleView,
  requestedQuantity,
  searchType,
  searchQuery,
  onUpdateQuery,
}: Props) {
  return (
    <div className='grid gap-2'>
      {items.map((offer) => (
        <Col
          key={offer.tyre.ean}
          bsPrefix='g-col'
          xs={12}
          sm={12}
          md={6}
          lg={6}
          xl={4}
          xxl={4}
        >
          <QuoteProductResult
            pointOfSaleView={pointOfSaleView}
            tyreOffer={offer}
            defaultQuantity={requestedQuantity}
            customer={customer}
            showBfDiscount={quoteSetting.showBfDiscount ?? true}
            searchType={searchType}
            searchQuery={searchQuery}
            onUpdateQuery={onUpdateQuery}
          />
        </Col>
      ))}
    </div>
  );
}

export default QuoteStandardDisplay;
